<button
  [type]="type"
  class="btn {{class}}"
  [ngClass]="{'show-scroll': showScroll}"
  (click)="onScrollTop()"
>
  <div class="btn-content">
    <span>
      <ng-content></ng-content>
    </span>
  </div>

</button>
